import React from "react";
import { Container } from "reactstrap";
import "./HeadTitle.css";


export function HeadTitle({ title, subtitle }) {
      return (
            <Container className="mt-5">
                  <h6 className="p-2 text-center title-header">
                  {title} 
                  {subtitle ? <h3 className="mt-3" style={{fontWeight:"bold"}}>{subtitle}</h3>: <></>}                  
                        <div className=" mt-4 d-flex justify-content-center align-items-center">
                              <div className="line-1 mx-1"></div>
                              <div className="circle"></div>
                              <div className="line-2 mx-1"></div>
                        </div>
                  </h6>
            </Container>
      );
};

